import { useId } from 'react';
import { haptics } from '../lib/platform';
import s from './Segmented.module.css';

interface SegmentedProps<T extends string> {
  value: T;
  options: { value: T; label: string }[];
  onChange: (value: T) => void;
  label: string;
}

/** A pill switch for two to four views, like Upcoming / Past. */
export function Segmented<T extends string>({
  value,
  options,
  onChange,
  label,
}: SegmentedProps<T>) {
  const id = useId();
  const index = Math.max(
    0,
    options.findIndex((o) => o.value === value),
  );
  return (
    <div
      className={s.root}
      role="tablist"
      aria-label={label}
      style={{ '--count': options.length, '--index': index } as React.CSSProperties}
    >
      <span className={s.thumb} aria-hidden="true" />
      {options.map((o) => (
        <button
          key={o.value}
          id={`${id}-${o.value}`}
          type="button"
          role="tab"
          aria-selected={o.value === value}
          className={s.option}
          onClick={() => {
            if (o.value !== value) {
              void haptics.tick();
              onChange(o.value);
            }
          }}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
